
export const conversionOptions = [
    { value: 'Spot', label: 'Spot' },
    { value: 'Average', label: 'Average' },
];

export const basisOptions = [
    { value: 'Daily', label: 'Daily' },
    { value: 'Monthly', label: 'Monthly' },
    { value: 'Quarterly', label: 'Quarterly' },
    { value: 'Calendar year', label: 'Calendar year' },
    { value: 'Financial year', label: 'Financial year' },
]

export const monthOptions = [
    { value: '0',  label: 'Month',   },
    { value: '1', label: 'January',   },
    { value: '2',  label: 'February',  },
    { value: '3',  label: 'March',     },
    { value: '4', plabel: 'April',     },
    { value: '5', label: 'May',       },
    { value: '6', label: 'June',      },
    { value: '7', label: 'July',      },
    { value: '8', label: 'August',    },
    { value: '9', label: 'September', },
    { value: '10',  label: 'October',   },
    { value: '11',  label: 'November',  },
    { value: '12',  label: 'December',  },
]

export const dateOptions = [
    { value: '0', label: 'dd mm yyyy',   },
    { value: '1', label: 'mm dd yyyy',   },
    { value: '2', label: 'yyyy mm dd',   },
]